import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=872aef26&scoped=true&"
import script from "./Panorama.vue?vue&type=script&lang=js&"
export * from "./Panorama.vue?vue&type=script&lang=js&"
import style0 from "./Panorama.vue?vue&type=style&index=0&id=872aef26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872aef26",
  null
  
)

export default component.exports